export default "__VITE_ASSET__DLg0xx5a__"